module.exports = __webpack_public_path__ + "img/9788963717579.b538ee0f.jpg";